// Moved verbatim from `src/hooks/mutation/useMutateRecordNoteSuggestionFeedback.ts`
// (now a re-export shim) at the session opener, ARCFE-983. Import re-points
// only: the api fn from the package carve, logger from the runtime door.
import { logger } from '@heidi/runtime/logger';
import { useMutation } from '@tanstack/react-query';
import { type RecordNoteSuggestionFeedbackRequest } from '../../contracts';
import { recordNoteSuggestionFeedback } from '../api/feedback';

export const RECORD_NOTE_SUGGESTION_FEEDBACK = 'recordNoteSuggestionFeedback';

type Input = {
  suggestionId: string;
  feedback: RecordNoteSuggestionFeedbackRequest['feedback'];
};

/**
 * Fire-and-forget POST to the note-suggestions feedback endpoint.
 *
 * Swallows and logs errors: the user has already resolved the suggestion
 * locally (strategy dropped from the atom), so a failure here must not
 * block the UI or surface a toast. The server side is one-shot — a 409
 * on retry is expected if the same suggestion is resolved twice (e.g.
 * network retry after success), so we don't retry on 4xx.
 */
export function useMutateRecordNoteSuggestionFeedback() {
  return useMutation({
    mutationKey: [RECORD_NOTE_SUGGESTION_FEEDBACK],
    mutationFn: async ({ suggestionId, feedback }: Input) => {
      return await recordNoteSuggestionFeedback({
        suggestionId,
        request: { feedback },
      });
    },
    retry: false,
    onError: (error, variables) => {
      logger.error('[note_suggestions] failed to record suggestion feedback', {
        error,
        suggestionId: variables.suggestionId,
        feedback: variables.feedback,
      });
    },
  });
}
